const ajArgsAj = (contrato, tipoAjuste, concepto, numeroAjuste, valor, fechaHoraHoy) => {
  // let fechaHoy = new Date()
  // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  let fechaHoy = fechaHoraHoy.substr(0, 10)

  let creaColecc = []
  let argsAdd = {
    "fechaAjuste": fechaHoy,
    "contrato": contrato,
    "tipoAjuste": tipoAjuste,
    "concepto": concepto,
    "numeroAjuste": numeroAjuste,
    "valorAjuste": valor,
  }
  creaColecc.push(argsAdd)

  let colecc = {creaColecc}

  return colecc
}

export default ajArgsAj
